<template>
  <transition name="fade" mode="out-in">
    <div v-if="isAuthenticated" class="app-container">
      <simplebar data-simplebar-auto-hide="false" class="container-simplebar" ref="simplebar-content">
        <transition name="fade" mode="out-in">
          <router-view @formDataActionCalled="formDataActionCalled" @definitionError="definitionError" />
        </transition>
      </simplebar>
      <transition name="fade" mode="out-in">
        <div v-if="errorMsg" class="popup">
          <div class="w3-modal" @click.prevent>
            <div class="w3-modal-content definition-error">
              <simplebar data-simplebar-auto-hide="false">
                <div class="container">
                  <div>
                    <span class="w3-display-topright close_detail"><i class="sherpa-icon icon-cerrar" @click="popupClose()"></i></span>
                    <div class="w3-container">
                      <div class="w3-row popup-content">
                        <i class="sherpa-icon icon-ico_error"></i> {{ errorMsg }}
                      </div>
                    </div>
                  </div>
                </div>
              </simplebar>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import menu from '@/utils/menu'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'

export default {
  name: 'container',
  props: [
    'type',
    'content'
  ],
  data () {
    return {
      errorMsg: null
    }
  },
  components: {
    simplebar
  },
  mounted () {
    this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_GENERAL_SIDEBAR}`, this.$refs['simplebar-content'].SimpleBar)
  },
  methods: {
    formDataActionCalled (stay) {
      if (!stay) {
        this.goToParentMenu()
      }
    },
    goToParentMenu () {
      var path = this.$route.matched[this.$route.matched.length - 1].path
      var menuParent = menu.methods.getDefaultParentMenuPath(null, this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], path)
      this.$router.push(menuParent.parentContextPath + menuParent.contextPath).catch(() => {})
    },
    definitionError (error, resultError, container) {
      if (error && resultError) {
        this.errorMsg = resultError.requestErrorMsg
      }
    },
    popupClose () {
      this.errorMsg = null
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`])
  }
}
</script>

<style lang="scss">
#content {
  > .app-container {
    > .container-simplebar {
      position: absolute;
      top: 106px;
      bottom: 62px;
      right: 18px;
      left: 118px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/container/index.vue